import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'constants/routes';
import { CustomButton } from 'components/CustomButton/CustomButton';

export const SuccessPage: React.FC = () => {
  const navigate = useNavigate();

  const handleContinue = () => {
    navigate(ROUTES.login.path);
  };

  return (
    <div style={{ textAlign: 'center', padding: '50px' }}>
      <h1>Success!</h1>
      <p>Your password has been successfully changed.</p>
      <CustomButton type="primary" onClick={handleContinue} buttonSize="large">
        Go to Login
      </CustomButton>
    </div>
  );
}; 